import './sitefooter.scss';

class Sitefooter {
    constructor (element) {
        this.$sitefooter = element;
    }

    initialize () {
        if (!window.mediaMatch[1024].matches) {
            this.setAriaAttribute('role', true);
            this.handleTableRoleConcept(true);
        } else {
            this.setAriaAttribute('disabled', true);
            this.setAriaAttribute('role', true, true);
        }

        this.setEvents();
    }

    setEvents () {
        window.mediaMatch[1024].addEventListener('change', (match) => {
            if (!match.matches) {
                this.setAriaAttribute('role', true);
                this.handleTableRoleConcept(true);
            } else {
                this.setAriaAttribute('role', false);
                this.setAriaAttribute('role', true, true);
                this.handleTableRoleConcept(false);
            }
        });
    }

    // set all roles and aria attributes
    handleTableRoleConcept (state) {
        this.setAriaAttribute('aria-labelledby', state);
        this.setAriaAttribute('aria-expanded', state);
        this.setAriaAttribute('disabled', !state);
    }

    // if true added saved attributes and roles
    setAriaAttribute (attribute, state, desktop = false) {
        let $$attributeItems = [];

        if (desktop === true) {
            $$attributeItems = this.$sitefooter.querySelectorAll(`[data-desktop-${attribute}]`);
        } else {
            $$attributeItems = this.$sitefooter.querySelectorAll(`[data-${attribute}]`);
        }

        if ($$attributeItems.length > 0) {
            $$attributeItems.forEach(($attributeItem) => {
                if (state === true) {
                    if (desktop === true) {
                        $attributeItem.setAttribute(attribute, $attributeItem.getAttribute(`data-desktop-${attribute}`));
                    } else {
                        $attributeItem.setAttribute(attribute, $attributeItem.getAttribute(`data-${attribute}`));
                    }
                }

                if (state === false) {
                    $attributeItem.removeAttribute(attribute);
                }
            });
        }
    }
}

export { Sitefooter };

window.addEventListener('content.loaded', (e) => {
    const $footer = document.querySelector('[data-sitefooter="root"]');

    if ($footer) {
        const footer = new Sitefooter($footer);
        footer.initialize();
    }
});
